class FaqSection extends HTMLElement {
    constructor() {
        super();
        this.titles = this.querySelectorAll('.faq-section__blocks-benefits__title');
        this.descriptions = this.querySelectorAll('.faq-section__blocks-benefits__description');
    }

    closeAllPanels() {
        this.descriptions.forEach(description => {
            description.style.maxHeight = '0px';
            description.style.margin = '0';
            const title = description.previousElementSibling.previousElementSibling;
            title.classList.remove('active');
        });
    }

    connectedCallback() {
        this.titles.forEach(title => {
            title.addEventListener('click', () => {
                const divider = title.nextElementSibling;
                const description = divider.nextElementSibling;
                const isActive = title.classList.contains('active');

                if (!isActive) {
                    this.closeAllPanels();
                }

                title.classList.toggle('active');

                if (isActive) {
                    description.style.maxHeight = '0px';
                    description.style.margin = '0';
                } else {
                    description.style.maxHeight = description.scrollHeight + 'px';
                    description.style.margin = '20px 0 0 0';
                }
            });
        });
    }
}

if (!customElements.get('faq-element')) {
    customElements.define('faq-element', FaqSection);
}

document.addEventListener('DOMContentLoaded', function () {
    const categoryButtons = document.querySelectorAll('.faq-category');
    const faqBlocks = document.querySelectorAll('.faq-section__blocks-grid');

    if (categoryButtons.length > 0) {
        categoryButtons[0].classList.add('active');

        const initialCategory = categoryButtons[0].getAttribute('data-category');
        faqBlocks.forEach(block => {
            const blockCategory = block.getAttribute('data-category');
            if (initialCategory === 'all' || blockCategory === initialCategory) {
                block.style.display = 'block';
            } else {
                block.style.display = 'none';
            }
        });
    }

    categoryButtons.forEach(button => {
        button.addEventListener('click', function () {
            const category = this.getAttribute('data-category');
            categoryButtons.forEach(btn => btn.classList.remove('active'));
            this.classList.add('active');

            faqBlocks.forEach(block => {
                const blockCategory = block.getAttribute('data-category');

                if (category === 'all' || blockCategory === category) {
                    block.style.display = 'block';
                } else {
                    block.style.display = 'none';
                }
            });
        });
    });
});

